module.exports = __webpack_public_path__ + "media/img/talent_carrer-53fcd1b635f26e680f62669a08bc5b55.jpg";